module.exports = __webpack_public_path__ + "media/images/pepsi_digin_brunch_lv/Instagram-black-8e80df5f9af78f4504b17c6a2c6a6f2f.svg";